module.exports = __webpack_public_path__ + "static/OP3-ac87451309c6ac5d942989dff8ee7180.png";